import {
  BundleAddToBagButton,
  BundleCloseButton,
  BundleContainer,
  BundleContent,
  BundleCopy,
  BundleFooter,
  BundleHero,
  BundleIncluded,
  BundleLoading,
  BundleNoLocation,
  BundleProductCard,
  BundleSelectedItem,
  BundleSelectList,
  BundleSelectModal,
  BundleSlot,
} from './components';

// ─────────────────────────────────────────────────────────────────────────────

export const Bundle = {
  AddToBagButton: BundleAddToBagButton,
  CloseButton: BundleCloseButton,
  Container: BundleContainer,
  Content: BundleContent,
  Copy: BundleCopy,
  Footer: BundleFooter,
  Hero: BundleHero,
  Included: BundleIncluded,
  Loading: BundleLoading,
  NoLocation: BundleNoLocation,
  ProductCard: BundleProductCard,
  SelectList: BundleSelectList,
  SelectModal: BundleSelectModal,
  SelectedItem: BundleSelectedItem,
  Slot: BundleSlot,
};
